import { localStorageGet } from '../../utils';

/**
 * Cache key for the region's `uiSettings.dischargePlanEnabled`. Written by
 * ClientSettingsService on every settings load, read here - the same pair the
 * RiskAI entitlement uses (`nav.riskProduct` in high-risk-entitlement.ts).
 */
export const DISCHARGE_PLAN_FLAG_KEY = 'nav.dischargePlan';

/**
 * Does this CLIENT get the Discharge Plan feature - the screen, its nav entry,
 * the calendar marks on the bed board and the scheduled email?
 *
 * One function, because the readers must never disagree: the nav model
 * (NavigationScreensService.navCtx, shared by the legacy menu and the rail),
 * DischargePlanRouteGuard, and the bed board's env (which hides the Discharge
 * legend tile and with it every mark). The server enforces the same flag on
 * its routes with requireDischargePlanEnabled.
 *
 * SOURCE OF TRUTH: `region.uiSettings.dischargePlanEnabled` in Mongo, switched
 * on by the SNF AI admin (177) on Client Settings once the client has paid,
 * and reaching the app through snfs/getClientSettings.
 *
 * OPT-IN, like RiskAI: a paid option, so an unconfigured region gets nothing
 * and only an explicit `true` grants it. Read `=== true`, never coerced.
 *
 * WHY localStorage: this is read synchronously by callers that cannot inject
 * ClientSettingsService - NavigationScreensService sits inside the
 * auth -> nav -> settings -> auth module cycle. ClientSettingsService caches
 * this one key on every load, exactly as it does for `newNavigation` and
 * `nav.riskProduct`. The cache is a read-ahead, never the authority: the
 * region's value overwrites it on the next load, and it is per-browser.
 * Nothing cached (first load, logout cleared it, unparsable) reads as OFF;
 * DischargePlanRouteGuard waits for the load before it decides, so an
 * entitled client is not bounced on the first navigation after login.
 */
export function isDischargePlanEnabledForClient(): boolean {
  return localStorageGet(DISCHARGE_PLAN_FLAG_KEY) === true;
}
